import { B2T_COLUMN_STATE_STORAGE_KEY } from '../constants';

const getStorageKeyForColumnState = clientID =>
  (`${B2T_COLUMN_STATE_STORAGE_KEY}|${window.location.pathname}|${clientID}`);

export const saveColumnStateToLocalStorage = (gridApi, clientId) => {
  localStorage.setItem(getStorageKeyForColumnState(clientId), JSON.stringify(gridApi.getColumnState()));
};

export const loadColumnStateFromStorage = (gridApi, clientId) => {
  const columnState = localStorage.getItem(getStorageKeyForColumnState(clientId));
  if (columnState && gridApi) {
    gridApi.applyColumnState({ state: JSON.parse(columnState), applyOrder: true });
  }
};
